// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import MachineUpdateModalBody from './machine-update-modal-body';
import MachineUpdateModalHeader from './machine-update-modal-header';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import TcsmApproveDenyModal from '../../state/tcsm-approve-deny-modal';
import {WarrantyMediumModal} from '../../../../shared/components/modal';

const MachineStatusUpdateModal = props =>
    <section className='machine-status-update-modal'>
        <WarrantyMediumModal isOpen={props.machineStatusModal.isVisible}>
            <MachineUpdateModalHeader
                closeUpdateStatusChangeModal={props.closeUpdateStatusChangeModal}
                machineStatusModalAction={props.machineStatusModal.actionToTake}
            />
            <MachineUpdateModalBody
                machineStatusItemToUpdate={props.machineStatusItemToUpdate}
                machineStatusModalAction={props.machineStatusModal.actionToTake}
                onCommentsToDealerChange={props.onCommentsToDealerChange}
                onConfirmation={props.onConfirmation}
                onInternalDeereCommentsChange={props.onInternalDeereCommentsChange}
            />
        </WarrantyMediumModal>
    </section>;

MachineStatusUpdateModal.displayName = 'MachineStatusUpdateModal';
MachineStatusUpdateModal.propTypes = {
    closeUpdateStatusChangeModal: PropTypes.func.isRequired,
    machineStatusItemToUpdate: PropTypes.instanceOf(StatusChange).isRequired,
    machineStatusModal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired,
    onCommentsToDealerChange: PropTypes.func.isRequired,
    onConfirmation: PropTypes.func.isRequired,
    onInternalDeereCommentsChange: PropTypes.func.isRequired
};

export default MachineStatusUpdateModal;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/machine-status-updates/machine-status-update-modal.js